var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 1.15039,
    width: 34.5,
    height: 23.5,
    rx: 2.75,
    fill: "white",
    stroke: "#E2E8F0",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6253 17.1585H8.50494L6.91495 11.0927C6.83949 10.8136 6.67925 10.567 6.44354 10.4507C5.85531 10.1585 5.20712 9.926 4.5 9.80873V9.5752H7.91567C8.38708 9.5752 8.74064 9.92601 8.79957 10.3334L9.62454 14.7089L11.7438 9.5752H13.8052L10.6253 17.1585ZM14.9839 17.1585H12.9814L14.6304 9.5752H16.6328L14.9839 17.1585ZM19.2236 11.6761C19.2825 11.2677 19.636 11.0341 20.0485 11.0341C20.6967 10.9755 21.4028 11.0928 21.9921 11.3839L22.3456 9.7512C21.7564 9.51766 21.1082 9.40039 20.5199 9.40039C18.5764 9.40039 17.1622 10.4508 17.1622 11.9086C17.1622 13.0177 18.1639 13.6 18.871 13.9508C19.636 14.3006 19.9307 14.5341 19.8717 14.8839C19.8717 15.4086 19.2825 15.6422 18.6943 15.6422C17.9871 15.6422 17.28 15.4673 16.6329 15.1751L16.2793 16.8088C16.9864 17.1 17.7514 17.2173 18.4585 17.2173C20.6378 17.2749 21.9921 16.2255 21.9921 14.6504C21.9921 12.6669 19.2236 12.5506 19.2236 11.6761V11.6761ZM29.0002 17.1585L27.4102 9.5752H25.7023C25.3488 9.5752 24.9952 9.80873 24.8774 10.1585L21.9331 17.1585H23.9945L24.406 16.0505H26.9388L27.1745 17.1585H29.0002ZM25.9967 11.6177L26.5849 14.4757H24.936L25.9967 11.6177Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVisa);
export default __webpack_public_path__ + "static/media/logo_visa.08af7ad5ffa2064f08acdfcd0cf01d75.svg";
export { ForwardRef as ReactComponent };